import React from "react";
import {Wrapper} from "./UserDocuments.styles";
import {NavLink, Outlet} from "react-router-dom";
import {AppRoutes} from "../../../logic/core/routes";
import {useBaseScreenHook} from "../../../logic/core/base-screen.hook";


const UserDocuments = () => {
    const {t} = useBaseScreenHook();


    return <Wrapper>
        <div className="document-tabs">
            <NavLink className={`tab`} to={AppRoutes.events}>
                {t('documents.events')}
            </NavLink>
            <NavLink className={`tab`} to={AppRoutes.organization}>
                {t('documents.organization')}
            </NavLink>
        </div>

        <Outlet/>

    </Wrapper>
}

export default UserDocuments;